<template>
    <header class="header">
        <div class="navigation-trigger hidden-xl-up" :class="{toggled: sidebarOpen}" @click="toggleSidebar">
            <div class="navigation-trigger__inner">
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
            </div>
        </div>

        <div class="header__logo hidden-sm-down">
            <h1><a href="/">Primary Origin</a></h1>
        </div>

        <!--<form class="search">-->
        <!--<div class="search__inner">-->
        <!--<input type="text" class="search__text" placeholder="Search for people, files, documents...">-->
        <!--<i class="zmdi zmdi-search search__helper" data-ma-action="search-close"></i>-->
        <!--</div>-->
        <!--</form>-->

        <ul class="top-nav">
            <!--<li class="dropdown top-nav__notifications">-->
                <!--<a href="" data-toggle="dropdown" class="top-nav__notify">-->
                    <!--<i class="zmdi zmdi-notifications"></i>-->
                <!--</a>-->
            <!--</li>-->
            <li>
                <router-link :to="{name: 'setup'}"><i class="zmdi zmdi-settings"></i></router-link>
            </li>
            <li v-if="$root.ghosting">
                <a href="#" @click.prevent="$root.stopGhosting" class="text-warning" v-b-tooltip title="Stop ghosting">
                    <i class="zmdi zmdi-accounts"></i>
                </a>
            </li>
        </ul>
    </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: ['sidebarOpen'],
  methods: {
    toggleSidebar() {
      this.$emit(this.sidebarOpen ? 'closeSidebar' : 'openSidebar');
    },
  },
};
</script>
